// extracted by mini-css-extract-plugin
export default {"font":"Home_font__9ocCa","profilePicture":"Home_profilePicture__2gRBq"};